import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import { api } from '../services/api';
import { PERMISSOES } from './rhFields';
import { useEquipes } from '../context/EquipesContext';
import { useAuth } from '../context/AuthContext';
import PasswordInput from './PasswordInput';

const FORM_VAZIO = {
  username: '',
  password: '61Imoveis',
  team: '',
  permissao: '',
  nome: '',
  email: '',
  telefone: '',
  instagram: '',
  descricao: '',
  id_imoview: '',
};

function Cadastro() {
  const { equipesOpcoes } = useEquipes();
  const { isAssistente, isAdministrador } = useAuth();
  const permissoesDisponiveis = isAdministrador
    ? PERMISSOES
    : PERMISSOES.filter((p) => !isAssistente || p.podeCriarComoAssistente);
  const [formData, setFormData] = useState({ ...FORM_VAZIO });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 8) {
      toast('A senha deve ter no mínimo 8 caracteres.', 'error');
      return;
    }

    if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email)) {
      toast('E-mail inválido.', 'error');
      return;
    }

    const payload = {
      ...formData,
      telefone: formData.telefone ? formData.telefone.replace(/\D/g, '') : '',
    };

    setLoading(true);
    try {
      await api.post('/auth/cadastro', payload);
      toast('Usuário cadastrado e já liberado para login!', 'success');
      setFormData({ ...FORM_VAZIO });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      toast(error.message || 'Erro de conexão com o servidor.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ds-auth-wrapper">
      <div className="ds-auth-card ds-auth-card--wide">
        <span className="ds-auth-accent" />
        <h2 className="ds-auth-title">Cadastro de Usuário</h2>
        <p className="ds-auth-subtitle">
          Preencha os dados do novo usuário. O acesso já nasce liberado — não precisa passar pelo RH.
        </p>

        <form className="ds-form" onSubmit={handleSubmit}>
          <div className="ds-form-row">
            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-username">Username *</label>
              <input id="reg-username" className="ds-input" name="username"
                type="text" placeholder="Username" value={formData.username}
                onChange={handleChange} required disabled={loading} />
            </div>

            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-nome">Nome completo *</label>
              <input id="reg-nome" className="ds-input" name="nome"
                type="text" placeholder="Nome completo" value={formData.nome}
                onChange={handleChange} required disabled={loading} />
            </div>
          </div>

          <div className="ds-form-row">
            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-email">E-mail</label>
              <input id="reg-email" className="ds-input" name="email"
                type="email" placeholder="email@exemplo.com" value={formData.email}
                onChange={handleChange} disabled={loading} />
            </div>

            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-tel">Telefone</label>
              <input id="reg-tel" className="ds-input" name="telefone"
                type="text" placeholder="(61) 9 9999-9999" value={formData.telefone}
                onChange={handleChange} disabled={loading} />
            </div>
          </div>

          <div className="ds-form-row">
            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-team">Equipe</label>
              <select id="reg-team" className="ds-input ds-select" name="team"
                value={formData.team} onChange={handleChange} disabled={loading}>
                <option value="">Sem equipe</option>
                {equipesOpcoes.map((equipe) => (
                  <option key={equipe.value} value={equipe.value}>{equipe.label}</option>
                ))}
              </select>
              <small className="ds-hint">
                Administrativo, inteligência e estagiário podem ficar sem equipe.
              </small>
            </div>

            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-imoview">Código Imoview</label>
              <input id="reg-imoview" className="ds-input" name="id_imoview"
                type="text" inputMode="numeric" placeholder="Ex: 112"
                value={formData.id_imoview} onChange={handleChange} disabled={loading} />
              <small className="ds-hint">
                Código do corretor no Imoview. Sem ele o corretor não aparece no seletor do Lançar Imóvel.
              </small>
            </div>
          </div>

          <div className="ds-form-row">
            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-insta">Instagram</label>
              <input id="reg-insta" className="ds-input" name="instagram"
                type="text" placeholder="@usuario" value={formData.instagram}
                onChange={handleChange} disabled={loading} />
            </div>

            <div className="ds-form-group">
              <label className="ds-label" htmlFor="reg-perm">Permissão *</label>
              <select id="reg-perm" className="ds-input ds-select" name="permissao"
                value={formData.permissao} onChange={handleChange} required disabled={loading}>
                <option value="">Selecione...</option>
                {permissoesDisponiveis.map((p) => (
                  <option key={p.value} value={p.value}>{p.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="reg-desc">Descrição</label>
            <textarea id="reg-desc" className="ds-input ds-textarea" name="descricao"
              placeholder="Descrição (opcional)" value={formData.descricao}
              onChange={handleChange} rows={3} disabled={loading} />
          </div>

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="reg-pass">Senha *</label>
            <PasswordInput id="reg-pass" name="password"
              placeholder="Mínimo 8 caracteres" value={formData.password}
              readOnly autoComplete="off" />
            <small className="ds-hint">
              Senha inicial padrão. No primeiro acesso, o usuário deverá definir e confirmar uma senha pessoal.
            </small>
          </div>

          <div className="ds-divider" />

          <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
            <button type="submit" className="ds-btn ds-btn-primary" style={{ flex: 1 }} disabled={loading}>
              {loading ? <><span className="ds-spinner" /> Cadastrando...</> : 'Cadastrar'}
            </button>
            <button type="button" className="ds-btn ds-btn-secondary" onClick={() => navigate('/')} disabled={loading}>
              Voltar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Cadastro;
